import './FloatingShapes.css'

const FloatingShapes = () => {
  return (
    <div className="floating-shapes">
      <i className="fas fa-cross shape cross shape-1"></i>
      <i className="fas fa-dove shape dove shape-2"></i>
      <i className="fas fa-heart shape heart shape-3"></i>
      <i className="fas fa-cross shape cross shape-4"></i>
      <i className="fas fa-dove shape dove shape-5"></i>
      <i className="fas fa-praying-hands shape heart shape-6"></i>
    </div>
  )
}

export default FloatingShapes

